'use strict';

const Marionette = require('backbone.marionette');
const TextAreaInput = require('./text-area').default;
const MultipleChoiceInput = require('./multiple-choice').default;

export default Marionette.CollectionView.extend({
  className: 'form-questions',
  tagName: 'div',

  childView: function(item) {
    if (item.isText()) {
      return TextAreaInput;
    }

    if (item.isMultipleChoice()) {
      return MultipleChoiceInput;
    }

    return TextAreaInput;
  },

  validateFormQuestions: function() {
    return this.collection.validateFormQuestions();
  },

  getErrors: function() {
    return this.collection.getErrors();
  },

  showError: function(error) {
    const { questionId, message } = error;
    const question = this.collection.findWhere({ id: questionId });
    const view = this.children.findByModel(question);

    if (view && message) {
      view.$el.children(`#custom-question-${questionId}`).addClass('invalid');
      view.$el.after('<div class="form-error">' + message + '</div>');
    }
  },
});
